import script from "./ChannelIdentityPicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChannelIdentityPicker.vue?vue&type=script&lang=ts&setup=true"

import "./ChannelIdentityPicker.vue?vue&type=style&index=0&id=8502db52&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8502db52"]])

export default __exports__